<template>
  <b-navbar toggleable="lg" type="dark" class="bg-user-primary">
    <b-navbar-brand v-if="image" :to="image.redirectPath"><img class="parks-image" role="button" :src="image.src" /> </b-navbar-brand>
    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav>
        <b-nav-item link-classes="text-bg-user-primary" v-for="(tab, index) in menu.filter(tab => tab.alignLeft)" :key="index" :to="tab.href">
          <div class="nav-not-selected mr-2"> <i :class="tab.icon" />  {{tab.title}} <b-badge v-if="tab.title === 'Email' && unread > 0" variant="danger">{{unread}}</b-badge><b-badge v-else-if="tab.title === 'Chat' && unreadChat > 0" variant="danger">{{unreadChat}}</b-badge></div>
        </b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <b-nav-item link-classes="text-bg-user-primary" v-for="(tab, index) in menu.filter(tab => !tab.alignLeft)" :key="index" :to="tab.href">
          <div class="nav-not-selected mr-2"> <i :class="tab.icon" />  {{tab.title}} <b-badge v-if="tab.title === 'Email' && unread > 0" variant="danger">{{unread}}</b-badge><b-badge v-else-if="tab.title === 'Chat' && unreadChat > 0" variant="danger">{{unreadChat}}</b-badge></div>
        </b-nav-item>
        <b-nav-item-dropdown right toggle-class="text-bg-user-primary">
          <!-- Using 'button-content' slot -->
          <template #button-content>
            <div class="nav-not-selected d-inline-block text-bg-user-primary">{{ user.name }} </div>
          </template>
          <div class="dropdown-size">
            <div v-for="(item, index) in userMenu" :key="index">
              <a v-if="(item.href === 'Logout')" @click="logout"><span class="dropdown-link text-user-primary"><i :class="item.icon" /> {{item.title}}</span></a>
              <router-link v-else :to="item.href"><span class="dropdown-link text-user-primary"><i :class="item.icon" /> {{item.title}}</span></router-link>
              <hr v-if="index !== userMenu.length - 1">
            </div>
          </div>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'


export default {
  components: {
  },

  data: () => ({
    appName: window.config.appName,
    tabs: [],
    userMenu: [],
    image: {},
    path: localStorage.getItem('path'),
    groupID: '',
    isActive: null,
    mini: true,
  }),

  computed: {
    ...mapGetters({
      user: 'auth/user',
      unread: 'email/unreadEmails',
      unreadChat: 'chat/unreadMessages',
      classId: 'auth/classId',
      getCompletedEvents: 'events/getCompletedEvents',
    }),
    menu: function() {
      return this.tabs.filter(tab => {
        if (tab.showAfterEvent) {
          return this.getCompletedEvents.includes(tab.showAfterEvent)
        }
        return !tab.header
      })
    },
  },

  created() {
    axios.post('/api/pcs/tabs', {
      params: {
        pcs: localStorage.getItem('pcs'),
      },
    })
      .then(response => {
        this.tabs = response.data['settings']['tabs']
        this.userMenu = response.data['settings']['userMenu']
        this.image = response.data['settings']['image']
      })
  },

  methods: {
    ...mapActions({
      _logout: 'auth/logout',
      clearState: 'events/clearState',
    }),
    async logout() {
      // Log out the user.
      await this._logout()
      await this.clearState()

      // Redirect to login.
      this.$router.push({ name: 'home' })
    },
  },
}
</script>

<style scoped lang="scss">
.nav-not-selected {
  text-transform: uppercase;
  font-family: sans-serif;
  cursor: pointer;
  text-decoration: none;
  font-weight: normal;
  font-size: 13pt;
}
.dropdown-link {
  color: black;
  font-family: sans-serif;
  font-weight: normal;
  cursor: pointer;
}
.dropdown-link:hover {
  text-decoration: underline;
}
.parks-image {
  position:relative; 
  z-index: 100;
  max-height: 45px; 
  border-radius: 30%;
}
.dropdown-size {
  display: block;
  padding: 6px;
}
</style>
